import { ThemeStyles } from '@apia/theme';

const hideWhenPrinting = [
  '.dropzone',
  '.grid__footer',
  '.twoColumns__aside',
  '.fieldWrapper.type_button',
  '[data-variant="layout.footerResponsiveButtons"]',
  '.twoColumns__main__bodyAside',
  '.notification',
  '.grid__header',
  '.grid__row',
].join(', ');

const showWhenPrinting: ThemeStyles = {
  '.dataGrid__printRow': { display: 'table-row' },
};

const hideWhenNotPrinting = ['.dataGrid__printRow'].join(', ');

const showWhenNotPrinting: ThemeStyles = {
  '.grid__row': { display: 'table-row' },
};

const print: ThemeStyles = {
  '@media screen': {
    [hideWhenNotPrinting]: {
      display: 'none !important',
    },
    ...showWhenNotPrinting,
  },
  '@media print': {
    '*': {
      overflow: 'visible !important',
    },

    '[data-type="grid"]': {
      height: 'auto',
    },

    '#root, body, html': {
      background: 'white !important',
    },

    [hideWhenPrinting]: {
      display: 'none !important',
    },

    ...showWhenPrinting,

    '.tabs__render__child': {
      display: 'block',
      breakInside: 'auto',
      border: '1px solid',
      borderColor: 'palette.border.section',
    },

    '.selection__keyHandler': {
      breakInside: 'auto',
    },

    '.fieldWrapper': {
      '.tree': {
        maxHeight: 'unset',
      },
    },
  },
};

export default print;
